export default __webpack_public_path__ + "static/media/video-play.04a9839e.svg";